import React, { useState } from 'react';
import { withErrorBoundary, CustomModal } from '@nile/components';
import { ChartHomeContextProvider } from '@nile/reports/src/modules/charts/contexts/Chart/home';
import ChartCascade from '@nile/reports/src/modules/charts/components/pages/ChartCascade';
import styled from 'styled-components';
import { Modal } from '@superops/ui-design-system';
import { ChartContextProvider } from '../../../contexts/Chart';
import DataTable from '../../subpages/DataTable';

const ContentWrapper = styled.div`
  min-height: calc(100vh - 200px);
  width: calc(100vw - 160px);
`;

const ChartHome = (props) => {
  const {
    callBack,
    mode,
    chart = null,
    removeChart,
    hideDelete,
    source = 'chart',
    layoutRef
  } = props;

  const [selectedChart, setSelectedChart] = useState({ data: null, index: 0 });

  const providerValue = {
    closeModal: callBack,
    removeChart: removeChart,
    layoutRef: layoutRef,
    hideDelete: hideDelete
  };

  return (
    <>
      <ChartHomeContextProvider value={providerValue}>
        <CustomModal open zIndex={380} onClose={() => callBack(false)} locked>
          <ContentWrapper className="fh">
            <ChartCascade
              mode={mode}
              chartId={chart && chart.chartId}
              source={source}
              numberChartCallback={(chartData) => {
                setSelectedChart(chartData);
              }}
            />
          </ContentWrapper>
        </CustomModal>
      </ChartHomeContextProvider>
      {/* Data table view of the chart */}
      {selectedChart.data != null && (
        <Modal
          large
          open
          onClose={() => setSelectedChart({ data: null, index: 0 })}
        >
          <ChartContextProvider
            value={{
              value: selectedChart?.data,
              isEdit: true,
              metricIndex: selectedChart?.index
            }}
          >
            <DataTable
              showExportButton={selectedChart?.data?.chartId}
              tableHeader={selectedChart?.data?.name}
              isTableOpen={true}
              isTableEditable={false}
              disableToggle={true}
              isFromWidgetView
            />
          </ChartContextProvider>
        </Modal>
      )}
    </>
  );
};

export default withErrorBoundary(ChartHome);
